import customAxios from "../../customAxios";
import { FIND_DRIVER } from "../../routes";
import { IRequestDriver } from "../../../types/driver.interface";
import { ICreateAndUpdateMunicipality } from "../../../types/municipality.interface";
import { ICreateAndUpdateCompany } from "../../../types/company.interface";

async function findDriver(props: IRequestDriver) {
  var thisUrl = FIND_DRIVER;

  let body: any = {
    page: props.page,
    limit: props.limit,
    populate: "cities company municipality",
  };

  if (props.search) {
    body = {
      ...body,
      search: {
        searchMode: props?.search?.base,
        searchValue: props?.search?.value,
      },
    };
  }
  if (props.filters) {
    const { municipality, company, cities } = props?.filters;
    body = {
      ...body,
      municipality: (municipality as ICreateAndUpdateMunicipality)?._id,
      company: (company as ICreateAndUpdateCompany)?._id,
      cities,
    };
  }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ FIND_DRIVER: error });
  }
}

export default findDriver;
